<template>
    <div class="block-promo" id="block-promo">
        <BlockParallax class="block-promo__icon block-promo--ph1 block-promo--icon-desktop" speed="7">
            <img src="@/assets/images/icons/ph-2.png">
        </BlockParallax>
        <BlockParallax class="block-promo__icon block-promo--ph2 block-promo--icon-desktop" speed="8" direction="left">
            <img src="@/assets/images/icons/ph-2.png">
        </BlockParallax>
        <BlockParallax class="block-promo__icon block-promo--hp1" speed="11" direction="left">
            <img src="@/assets/images/icons/hp-1.png">
        </BlockParallax>
        <BlockParallax class="block-promo__icon block-promo--hp2 block-promo--icon-desktop" speed="8" direction="left" offset="100">
            <img src="@/assets/images/icons/hp-1.png">
        </BlockParallax>

        <BlockParallax class="block-promo__icon block-promo--zapato1 block-promo--icon-desktop" speed="20" direction="right">
            <img src="@/assets/images/icons/kk-1.png">
        </BlockParallax>
        <BlockParallax class="block-promo__icon block-promo--zapato2" speed="20" direction="left">
            <img src="@/assets/images/icons/kk-1.png">
        </BlockParallax>

        <BlockParallax class="block-promo__icon block-promo--lightning1" speed="15" direction="right">
            <img src="@/assets/images/icons/ll-2.png">
        </BlockParallax>
        <BlockParallax class="block-promo__icon block-promo--lightning2" speed="15" direction="left">
            <img src="@/assets/images/icons/ll-2.png">
        </BlockParallax>
        <BlockParallax class="block-promo__icon block-promo--lightning3 block-promo--icon-desktop" speed="15" direction="left">
            <img src="@/assets/images/icons/ll-2.png">
        </BlockParallax>
        <BlockParallax class="block-promo__icon block-promo--lightning4 block-promo--icon-desktop" speed="15" direction="right">
            <img src="@/assets/images/icons/ll-2.png">
        </BlockParallax>
        <BlockParallax class="block-promo__icon block-promo--lightning5 block-promo--icon-desktop" speed="11" direction="right">
            <img src="@/assets/images/icons/ll-2.png">
        </BlockParallax>
        <div class="main-wrap">
            <div class="block-promo__content">
                <p class="block-promo__title">12-15</p>
                <p class="block-promo__text">
                    Переходный возраст, бунт, тусовки, музыка и другие увлечения. Все это вместе с желанием изменить мир, неуверенностью в себе и большими планами на будущее.
                </p>
                <icon-arrow class="block-promo__arrow" v-scroll-to="'#block-info-four'" />
            </div>
        </div>
    </div>
</template>

<script>
import BlockParallax from '@/components/blocks/parallax'

export default {
    components: {
        BlockParallax
    }
}
</script>


<style scoped lang="stylus">
    .block-promo {
        position relative
        background-color #8d91e6
        overflow hidden
        background-image url('~@/assets/images/icons/dash-path-2m.svg'),
        url('~@/assets/images/icons/dot-path-1m.svg'),
        url('~@/assets/images/icons/dot-path-2m.svg'),
        url('~@/assets/images/icons/dash-path-1m.svg')
        background-repeat no-repeat
        background-position top left, top left, top right, bottom right
        background-size 7rem, 10rem, 4.6rem, 10rem
        +layout-md-and-up() {
            position relative
            background-image url("~@/assets/images/icons/dash-path-1.svg") , url('~@/assets/images/icons/dot-path-1.svg') , url("~@/assets/images/icons/dash-path-2.svg") , url("~@/assets/images/icons/dot-path-2.svg")
            background-position left 138px bottom, left 165px top, right 156px top, right 259px top
            background-size contain, contain, contain, contain
        }

        &__content {
            position relative
            +layout-md-and-up() {
                display flex
                flex-direction column
                align-items center
                padding-bottom 5rem

            }
        }

        &__title {
            font-size 5.6rem
            color #FFFFFF
            font-weight 900
            letter-spacing 0.61px
            margin 2.7rem 0 0
            padding 0 0 0 5rem

            +layout-sm-and-up() {
                text-align center
                padding 0
            }
            +layout-md-and-up() {
                font-size 8rem
                letter-spacing 0.87px
                margin 12rem 0 0
                padding 0
            }
        }

        &__text {
            box-sizing border-box
            margin 0
            padding 2rem 2rem 13rem 5rem
            font-size 1.5rem
            line-height 1.47
            color $color-white

            +layout-sm-and-up() {
                text-align center
                font-size 1.8rem
                line-height 2.8rem
                letter-spacing 0.19px
            }
            +layout-md-and-up() {
                width 100%
                max-width 63rem
                padding-bottom 0
                padding-top 2.1rem

            }
        }

        &__icon {
            position absolute
            max-width 100%
            img {
                position relative
            }
        }

        &--icon-desktop {
            display none
            +layout-md-and-up() {
                display block
            }
        }

        &--ph2 {
            right 0.8rem
            width 6.2rem
            transform rotate(65deg)
            +layout-md-and-up() {
                top 3rem
                right 31.4rem
                width 8rem
                img {
                    transform: rotate(-25deg);
                }
            }
        }

        &--ph1 {
            +layout-md-and-up() {
                width 10.2rem
                left 310px
                bottom 39px
                img {
                    transform rotate(-115deg)
                }
            }
        }

        &--hp1 {
            left 11rem
            bottom 2rem
            transform rotate(52deg)
            width 8rem
            +layout-md-and-up() {
                bottom auto
                top 15rem
                left 18rem
                width 11.3rem
                img {
                    transform rotate(-220deg)
                }
            }
        }

        &--hp2 {
            // left 3.7rem
            // bottom 2.2rem
            // transform rotate(239deg)
            width 9.2rem
            +layout-md-and-up() {
                right 200px
                bottom 54px
                width 10rem
                img {
                    transform rotate(-72deg)
                }
            }
        }

        &__arrow {
            width 2rem
            position absolute
            right 0.6rem
            bottom 2rem
            animation translate 1.5s linear infinite forwards

            +layout-md-and-up() {
                position static
                padding-top 0
                margin-top 2rem
                padding-bottom 8.5rem
                cursor pointer

                &:hover {
                    fill $color-blue
                    cursor pointer
                    animation-play-state paused
                    opacity 0.7
                }
            }
        }

        &--zapato1 {
            top 2rem
            left 39rem
            img {
                transform rotate(45deg)
            }
        }
        &--zapato2 {
            top 5rem
            right 1rem
            width 5rem
            img {
                transform rotate(-230deg)
            }
            +layout-md-and-up() {
                top 17rem
                right 5rem
                width 9rem
            }
            
        }
        &--lightning1 {
            top 9px
            right 60px
            width 20px
            img {
                transform rotate(50deg)
            }
            +layout-md-and-up() {
                top 58px
                left 138px
                width 30px
                img {
                    transform rotate(-122deg)
                }
            }
        }
        &--lightning2 {
            bottom 8rem
            left 2rem
            width 3rem
            img {
                transform rotate(-6deg)
            }
            +layout-md-and-up() {
                left 123px
                bottom 60px
                width 40px
                img {
                    transform rotate(-179deg)
                }
            }
        }
        &--lightning3 {
            width 22px
            top 24rem
            right 22.5rem
            img {
                transform rotate(-150deg)
            }
        }
        &--lightning4 {
            top 2rem
            right 4rem
            width 36px
            img {
                transform: rotate(-186deg);
            }
        }
        &--lightning5 {
            bottom 5rem
            right 8rem
            width 32px
            img {
                transform: rotate(-85deg);
            }
        }
    }

</style>
